module.exports = __webpack_public_path__ + "2ffde12d5c1569d3d373a6417fe04d53.jpg";